<script setup>
  import {computed} from "vue";

  import {degreeOfCareLevel} from "@pages/Patients/Components/PatientAttributes/Enums.js";

  defineOptions({
    name: "ComponentPatientSidebarDegreeOfCareAttribute",
  });

  const props = defineProps({
    attribute: {
      type: Object,
      required: true,
    },
    patient: {
      type: Object,
      required: true,
    },
    inline: {
      type: Boolean,
      default: false,
    },
  });

  const helperText = computed(() => {
    return degreeOfCareLevel[Number.parseInt(props?.attribute?.payload?.level)] !== undefined
      ? degreeOfCareLevel[props.attribute.payload.level]
      : null;
  });
</script>

<template>
  <div :class="{'flex flex-wrap space-x-1.5': inline}">
    <h6 class="text-gray-600" :class="{'font-semibold': inline, 'text-xs uppercase': !inline}">
      Pflegegrad{{ inline ? ":" : "" }}
      <slot name="label" />
    </h6>

    <div class="flex items-start space-x-1.5" :class="{'mt-0.5 text-sm': !inline}">
      <slot>
        <strong :class="{'text-3xl font-normal': !inline, 'font-semibold': inline}">
          {{ attribute.payload?.level }}
        </strong>
        <span v-text="helperText" />
      </slot>
    </div>
  </div>
</template>
